import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchData } from '../../../helpers/fetchData';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import TextInput from '../../../shared/TextInput';
import DropdownField from '../../../shared/DropdownField';
import CustomButton from '../../../shared/CustomButton';
import { FaBan } from 'react-icons/fa';
import toast from 'react-hot-toast';
import CheckPermission from '../../../hooks/CheckPermission';
import { CANCEL_REASONS, OTHER_CANCEL_REASON } from '../../../constants/CancelReasons';
import { useCancelDepositBalanceMutation } from '../../../redux/api/modules/billingApi';

const CancelDepositBalanceForm = ({ selectedRow, setSelectedRow, payloadData,
  fetchInitialData, setOpenCancelBalanceModal }) => {
  const { hasPermission } = CheckPermission();
  const { t } = useTranslation();
 const [cancelDepositBalance, { isLoading }] = useCancelDepositBalanceMutation();
  const reasonOptions = CANCEL_REASONS.map(reason => ({ label: t(reason), value: reason }));

  const initialValues = {
    reason_type: '',
    other_reason: ''
  };
  const validationSchema = Yup.object().shape({
    reason_type: Yup.string().trim().required(t('Cancel reason is required')),
    other_reason: Yup.string().trim().when('reason_type', {
      is: OTHER_CANCEL_REASON,
      then: schema => schema.required(t('Cancel reason is required')),
      otherwise: schema => schema.notRequired()
    })
  });

  const handleSubmit = async (values) => {
    if (!hasPermission('deposit', 'update')) return;
    try {
       const cancel_reason =
        values.reason_type === OTHER_CANCEL_REASON
          ? values.other_reason.trim()
          : values.reason_type;
      const payload = {
        cancel_reason: cancel_reason,
        invoice_number: selectedRow?.invoice_number
      };

      const response = await cancelDepositBalance(payload).unwrap();
      setOpenCancelBalanceModal(false);
      if (setSelectedRow) setSelectedRow(null);
      toast.success(response?.message || t('Deposit cancelled successfully'));
      if (typeof fetchInitialData === 'function') {
        fetchInitialData(payloadData);
      }
    } catch (error) {
      toast.error(error?.data?.message || error?.message || t('Something went wrong'));
    }
  };

  return (
    <div>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ values }) => (
          <Form>
            <div className='mb-3'>
              <DropdownField
                name='reason_type'
                label={t('Reason for request')}
                placeholder={t('Select reason')}
                options={reasonOptions}
              />
            </div>
            {values.reason_type === OTHER_CANCEL_REASON && (
              <TextInput
                name='other_reason'
                label={t('Cancel Reason*')}
                placeholder={t('Enter cancel reason')}
                as='textarea'
                rows={4}
              />
            )}
            <div className='flex items-center justify-end mt-3 gap-2'>
              <CustomButton
                onClick={() => setOpenCancelBalanceModal(false)}
                label={t('Close')}
                icon='pi pi-times'
                buttonType='reset'
              />
              {hasPermission('deposit', 'update') && <CustomButton
                loading={isLoading}
                type='primary'
                icon={<FaBan size={15} className='me-2' />}
                label={t('Cancel Deposit')}
                buttonType='primary'
              />}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CancelDepositBalanceForm;
